import { Grid, Paper, Button } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import useReactHookForm from "hooks/useReactHookForm";
import ContentRight from "shared/molecules/content-right";
import { useEffect } from "react";
import { hasAtLeastOneValue, projectsFilterInitialValues, projectsFilterProperties, projectsFilterValidationSchema } from "./helper";
import { formatDateUtc } from "utils/time-util/utcIstTime";


export function ProjectsFilter({setSearchPayload,
  setPage,
  clearValuesTrigger}) {

  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    projectsFilterInitialValues,
    projectsFilterValidationSchema,
    "",
  );

  const handleSearch =()=>{
    const payload:any={};
    const searchName= watch("searchName");
    if(searchName) payload.searchName=searchName;

     const createdAt = watch("created_at");
        if (createdAt?.[0]) payload.createdFrom = formatDateUtc(createdAt[0]);
        if (createdAt?.[1]) payload.createdTill = formatDateUtc(createdAt[1], true);
    
        const updatedAt = watch("updated_at");
        if (updatedAt?.[0]) payload.updatedFrom = formatDateUtc(updatedAt[0]);
        if (updatedAt?.[1]) payload.updatedTill = formatDateUtc(updatedAt[1], true);

    setSearchPayload(payload);
    setPage(1);
  }

  const clearFilter = () =>{
    setValue("searchName","");
    setValue("created_at",[null, null]);
    setValue("updated_at",[null, null]);
    setSearchPayload({});
    setPage(1);
  }

  useEffect(()=>{
    clearFilter()
  },[clearValuesTrigger])

  return (
    //
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt:3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={projectsFilterProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(), ["searchName", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), ["searchName", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
